import { combineReducers } from 'redux';
import publicConfig from './publicConfig';
import privateConfig from './privateConfig';
import serverTimeOffset from './serverTimeOffset';
import webSocketErrorSentTime from './webSocketErrorSentTime';

export default combineReducers({
    publicConfig,
    privateConfig,
    serverTimeOffset,
    webSocketErrorSentTime,
});

export const getPublicConfig = (state) => state.publicConfig;
export const getPrivateConfig = (state) => state.privateConfig;
export const getServerTimeOffset = (state) => state.serverTimeOffset;
export const getWebSocketErrorSentTime = (state) => state.webSocketErrorSentTime;
